export const formatCurrency = (
  amount: number | string,
  fractioningDigits: number = 2
): string =>
  (typeof amount === "string" ? Number(amount) : amount).toLocaleString(
    "en-US",
    {
      minimumFractionDigits: fractioningDigits,
      maximumFractionDigits: fractioningDigits,
    }
  );

export const formatBalance = (
  amount: number | string,
  fractioningDigits: number = 2
) => {
  // Handle billions
  if (Number(amount) >= 10 ** 9) {
    return formatCurrency(Number(amount) / 10 ** 9, 2) + "B";
  }

  // Handle millions
  if (Number(amount) >= 10 ** 6) {
    return formatCurrency(Number(amount) / 10 ** 6, 2) + "M";
  }

  // Handle > 10K
  if (Number(amount) >= 10 ** 4) {
    return formatCurrency(Number(amount) / 10 ** 3, 2) + "K";
  }

  // Handle numbers less than 1000
  return formatCurrency(amount, fractioningDigits);
};
